// extracted by extract-css-chunks-webpack-plugin
module.exports = {"content_list":"content_list-2saS3n_t","chip_item":"chip_item-1Y6BDu4C","top_40":"top_40-16NSCdkH"};